import { ScorecardRecommendation } from "@/modules/recruitment/enums/ScorecardRecommendation"

export const SCORE_LABELS: Record<number, string> = {
  1: "Below bar",
  2: "Mixed",
  3: "Good",
  4: "Excellent",
}

export const SCORE_STYLES: Record<number, string> = {
  1: "bg-red-100 text-red-700 border-red-300 dark:bg-red-900/30 dark:text-red-400 dark:border-red-900/50",
  2: "bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-900/50",
  3: "bg-green-100 text-green-700 border-green-300 dark:bg-green-900/30 dark:text-green-400 dark:border-green-900/50",
  4: "bg-green-200 text-green-800 border-green-400 dark:bg-green-900/50 dark:text-green-300 dark:border-green-800",
}

export const RECOMMENDATION_LABELS: Record<ScorecardRecommendation, string> = {
  [ScorecardRecommendation.StrongNo]: "Strong no",
  [ScorecardRecommendation.No]: "No",
  [ScorecardRecommendation.Yes]: "Yes",
  [ScorecardRecommendation.StrongYes]: "Strong yes",
}

export const RECOMMENDATION_STYLES: Record<ScorecardRecommendation, string> = {
  [ScorecardRecommendation.StrongNo]:
    "bg-red-200 text-red-800 border-red-400 dark:bg-red-900/50 dark:text-red-300 dark:border-red-800",
  [ScorecardRecommendation.No]:
    "bg-red-100 text-red-700 border-red-300 dark:bg-red-900/30 dark:text-red-400 dark:border-red-900/50",
  [ScorecardRecommendation.Yes]:
    "bg-green-100 text-green-700 border-green-300 dark:bg-green-900/30 dark:text-green-400 dark:border-green-900/50",
  [ScorecardRecommendation.StrongYes]:
    "bg-green-200 text-green-800 border-green-400 dark:bg-green-900/50 dark:text-green-300 dark:border-green-800",
}

export const STALE_BADGE_STYLE =
  "bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-900/50"

export function getInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase()
}
